import { createSlice } from '@reduxjs/toolkit';
import { BillsOfMaterialsListStateType } from 'src/types/billsOfMaterialsList';
import { formatData } from './functions';

const initialState: BillsOfMaterialsListStateType = {
    data: null,
    loading: false,
    error: false,
    idBillOfMaterials: '',
};
export const billsOfMaterialListSlice = createSlice({
    name: 'billsOfMaterialList',
    initialState,
    reducers: {
        getBillsOfMaterialsListFetch: (state, action) => {
            state.loading = true;
            state.error = false;
            state.idBillOfMaterials = action.payload;
        },
        getBillsOfMaterialsListFetchSuccess: (state, action) => {
            state.data = formatData(action.payload);
            state.loading = false;
        },
        getBillsOfMaterialsListFetchFailure: (state, action) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
        activateBillOfMaterialsFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        activateBillOfMaterialsFetchSuccess: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        activateBillOfMaterialsFetchFailure: (state, action) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
        deactivateBillOfMaterialsFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        deactivateBillOfMaterialsFetchSuccess: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        deactivateBillOfMaterialsFetchFailure: (state, action) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
    },
});

export const {
    getBillsOfMaterialsListFetch,
    getBillsOfMaterialsListFetchSuccess,
    getBillsOfMaterialsListFetchFailure,
    activateBillOfMaterialsFetch,
    activateBillOfMaterialsFetchSuccess,
    activateBillOfMaterialsFetchFailure,
    deactivateBillOfMaterialsFetch,
    deactivateBillOfMaterialsFetchSuccess,
    deactivateBillOfMaterialsFetchFailure,
} = billsOfMaterialListSlice.actions;

export default billsOfMaterialListSlice.reducer;
